import type { NextPage } from 'next';
import { NextSeo } from 'next-seo';

const NotFoundPage: NextPage = () => {
  return (
    <>
      <NextSeo title="Page Not Found" />
      <p>page not found</p>
    </>
  );
};

export { getStaticProps } from 'getStaticProps';
export default NotFoundPage;
